
import { useWatch } from 'react-hook-form';import { memo, useContext } from 'react';

import { useLanguage } from '@languages/index';
import CampaignFormFieldGroup from '../../../../../campaignFormFieldGroup/campaignFormFieldGroup';
import PreferredVideoTypeField from './components/preferredVideoTypeField/preferredVideoTypeField';
import BeautyOutputFields from './components/beautyOutputFields/beautyOutputFields';
import VideoDurationField from './components/videoDurationField/videoDurationField';
import GuideImageField from '../../../formFields/guideImageField/guideImageField';
import BrandLogoField from './components/brandLogoField/brandLogoField';
import ReelsReferenceFields from '../../../formFields/reelsReferenceFields/reelsReferenceFields';
import EmblemField from './components/emblemField/emblemField';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';
import URLS from 'constants/urls';

const CampaignFormReelsGuidelineFieldGroup = () => {
  const language = useLanguage();
  const languageTexts = {
    ...language.pages.campaigns,
  };
  const { guidelineRuleFormMethods } = useContext(CampaignFormContext);

  const preferredVideoTypeValue = useWatch({
    control: guidelineRuleFormMethods.control,
    name: 'PREFERRED_VIDEO_TYPE.value',
  });

  return (
    <CampaignFormFieldGroup
      label={`2. ${languageTexts.create_reels_form_guideline}`}
    >
      <div className="flex flex-col">
        {/* 선호하는 영상 유형 */}
        <PreferredVideoTypeField />

        {/* 인플루언서에게 전달할 참고 릴스 URL */}
        <ReelsReferenceFields />

        {/* 영상 최소 길이 */}
        <VideoDurationField />

        {/* 필수 장면 */}
        <BeautyOutputFields />

        {/* 이미지 형식의 추가 가이드라인 (선택) */}
        <GuideImageField
          label={languageTexts.create_reels_form_image_guideline}
          description={languageTexts.create_reels_form_image_guideline_beauty}
          descriptionClassName="!text-[#FA0000]"
          uploadButtonText={languageTexts.create_reels_form_image_upload}
        />

        {/* 로고 형식의 추가 가이드라인 (선택) */}
        <BrandLogoField />

        {/* 엠블럼 형식의 추가 가이드라인 (선택) */}
        {([
          GUIDELINE_RULE_DTO_ENUMS.PREFERRED_VIDEO_TYPE_OPTIONS.OY_PRODUCT_ONLY,
          GUIDELINE_RULE_DTO_ENUMS.PREFERRED_VIDEO_TYPE_OPTIONS.OY_VISITING,
        ] as string[]).includes(preferredVideoTypeValue as string) && (
          <EmblemField
            label={languageTexts.create_reels_form_emblem_oliveyoung_guideline}
            emblemGroupName={GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.EMBLEM_OLIVEYOUNG}
            emblemUrls={[
              `${URLS.CDN.COMMON.IMAGES.GUIDELINES.EMBLEMS.OLIVEYOUNG_SALE.URL}/2512_1.png`,
              `${URLS.CDN.COMMON.IMAGES.GUIDELINES.EMBLEMS.OLIVEYOUNG_SALE.URL}/2512_2.png`,
            ]}
          />
        )}
      </div>
    </CampaignFormFieldGroup>
  );
};

export default memo(CampaignFormReelsGuidelineFieldGroup);
